import Applications from "../../../jsx/components/Dashboard/Applications/applications";

const ApplicatiionsWrapper = () => {
  return <Applications />;
};

export default constore(ApplicatiionsWrapper);
